import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { Observable } from "rxjs";
import { MeterModelSaveDto } from "../models/meter.model";

@Injectable({
  providedIn: 'root'
})
export class MeterModelService {
  
  private pathApi = this.config.setting['pathApi'] + "meterModel/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  getAllForSelect(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForSelect`, { observe: 'response' });
  }

  save(dataIn : MeterModelSaveDto): Observable<any> {
    return this.http.post(`${this.pathApi}save`, dataIn);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }
}